import AppBottomTab from "./AppBottomTab"

export default AppBottomTab